export default "__VITE_ASSET__BdI4UBla__"